import {
  CREATEZONE,
  CREATEZONE_SUCCESS,
  UPDATEZONE,
  UPDATEZONE_SUCCESS,
  FETCHZONES,
  FETCHZONES_SUCCESS,
  DELETEZONE,
  DELETEZONE_SUCCESS,
} from "constants/ActionTypes";

export const fetchZones = (applicationId) => {
  console.log('fetchZones', applicationId);
  return {
    type: FETCHZONES,
    payload: {
      applicationId: applicationId
    }
  };
};

export const fetchZonesSuccess = (zones, applicationId) => {
  console.log('fetchZonesSuccess', zones, applicationId);

  return {
    type: FETCHZONES_SUCCESS,
    applicationId: applicationId,
    payload: zones
  };
};

export const createZone = (creatingZone) => {
  console.log('creatingZone', creatingZone)
  return {
    type: CREATEZONE,
    payload: creatingZone
  };
};

export const createZoneSuccess = (createdZone) => {

  return {
    type: CREATEZONE_SUCCESS,
    payload: createdZone
  };
};

export const updateZone = (updatingZone) => {
  console.log('updatingZone', updatingZone)
  return {
    type: UPDATEZONE,
    payload: updatingZone
  };
};

export const updateZoneSuccess = (updatedZone) => {
  console.log('updatedZone', updatedZone)

  return {
    type: UPDATEZONE_SUCCESS,
    payload: updatedZone
  };
};

export const deleteZone = (deletingZone) => {

  return {
    type: DELETEZONE,
    payload: deletingZone
  };
};

export const deleteZoneSuccess = (deletedZone) => {

  return {
    type: DELETEZONE_SUCCESS,
    payload: deletedZone
  };
};
